export const environment = {
    production: true,
    api: 'https://reciclayaproappservice-api.azurewebsites.net/v1/',
    api_v2: 'https://reciclayaproappservice-api.azurewebsites.net/v2/',
    carrefour_login_url: 'https://www.carrefour.es/access?source=reciclaya&redirect=https://www.reciclaya.carrefour.es/tabs/tickets/import',
    consent: 'terms 2',
    token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'
};